import React from "react";
// import "./TrainingComp.css";
// import trainingImg2 from "../../Images/trainingImg2.webp";
// import trainingImg3 from "../../Images/trainingImg3.png";
import Homecom from '../../Components/trainingHome/Homecom1/Home';

const IndividualTraining = () => {
  return (
    <>
    {/* <div className="trainingCompSection">
      <div className="trainingCompSection2">
        <div className="section2text">
          <h2>Interview Preparation</h2>
          <p>
            Ace your interviews with confidence and clarity. Our Interview
            Preparation module is designed to help candidates shine in both HR
            and technical rounds. With mock interviews, personalized feedback,
            and expert-led sessions, we guide you through common questions, body
            language tips, and real-world scenarios. Whether you're targeting
            campus placements or corporate roles, this training builds your
            communication skills, boosts your confidence, and prepares you to
            make a lasting impression.
          </p>
        </div>
        
        <div className="section2Img">
          <img src={trainingImg2} alt="trainingImg2" />
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Java Full Stack</h3>
          <p>
            Learn to build dynamic web applications using Java, Spring Boot, and
            front-end frameworks like Angular or React.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Web Development</h3>
          <p>
            Master HTML, CSS, JavaScript, and responsive design principles to
            create modern, user-friendly websites.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Python Full Stack</h3>
          <p>
            Develop full-stack applications using Python, Django/Flask, and
            front-end technologies with real-world project exposure.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Cyber Security</h3>
          <p>
            Understand the fundamentals of ethical hacking, network security,
            and data protection through hands-on labs and simulations.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Data Science</h3>
          <p>
            Understand the fundamentals of ethical hacking, network security,
            and data protection through hands-on labs and simulations.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Data Analytics</h3>
          <p>
            Understand the fundamentals of ethical hacking, network security,
            and data protection through hands-on labs and simulations.
          </p>
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>HR Interview Mastery</h3>
          <p>
            Learn how to present yourself, answer behavioral questions, and
            navigate tricky scenarios with poise and professionalism.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Technical Interview Prep</h3>
          <p>
            Sharpen your subject knowledge and problem-solving skills with
            domain-specific mock interviews and expert insights.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Mock Interview Sessions</h3>
          <p>
            Experience simulated interviews with feedback to refine your
            responses, tone, and confidence.
          </p>
        </div>
      </div>
      <a href="/form">
        <button>Apply</button>
      </a>
      <div className="trainingCompSection2" id="aptitude">
        <div className="section2Img">
          <img src={trainingImg3} alt="trainingImg3" />
        </div>
        <div className="section2text">
          <h2>Aptitude Training</h2>
          <p>
            Crack competitive exams and placement tests with precision. Our
            Aptitude Training program covers essential topics like quantitative
            reasoning, logical thinking, data interpretation, and verbal
            ability. Each module includes timed assessments, practice questions,
            and strategic tips to help you improve speed and accuracy. Whether
            you're preparing for IT roles, government exams, or campus drives,
            this training builds a strong foundation for success.
          </p>
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Quantitative Reasoning</h3>
          <p>
            Master arithmetic, algebra, and number systems with step-by-step
            guidance and practice drills.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Logical Thinking</h3>
          <p>
            Develop analytical skills through puzzles, pattern recognition, and
            logic-based problem solving.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Data Interpretation</h3>
          <p>
            Learn to analyze charts, graphs, and tables quickly and accurately
            for real-world applications.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Verbal Ability</h3>
          <p>
            Enhance your grammar, vocabulary, and comprehension skills to tackle
            verbal sections with ease.
          </p>
        </div>
      </div>
      <a href="/form">
        <button>Apply</button>
      </a>
    </div> */}
    <Homecom/>
    </>
  );
};

export default IndividualTraining;
